<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2025-11-11 09:35:12
 * @LastEditors: sjq
 * @LastEditTime: 2026-01-14 09:50:28
 -->
<template>
  <div class="card-coupons">
    <div class="card-coupons_inner">
      <div :class="{ 'card-order-has_coupons': hasCoupons }">
        <div class="item-title item-lable ispay">
          实付
          <span class="reduce-price">(已省¥{{ reducePrice }})</span>
          <div class="item-value order-amount">
            <!-- 实付总价 -->
            <template v-if="orderAmountReal > 0">
              ¥
              <span>{{ orderAmountReal }}</span>
            </template>
          </div>
        </div>
      </div>
      <!-- 优惠券 -->
      <div v-if="preOrder.goodsInfo.discountCoupon === 1">
        <div v-show="!fromIntegral" class="item-lable iscoupon" @click="setCoupon">
          <div class="item-name">
            优惠券
            <div v-if="value.tag && !value.disabled" class="item-lable-tag">
              {{ value.tag }}
            </div>
          </div>
          <div class="item-value">
            <span v-if="!hasCoupons" class="tips">无可用优惠券</span>
            <span v-else-if="value.disabled">不可用</span>
            <span v-else class="discount_price_box">{{ value.priceLabel }}</span>
          </div>
          <img
            v-if="hasCoupons && !value.disabled"
            src="../../../../images/icon/icon_arrow_left.png"
            class="select_value_icon"
          />
        </div>
        <!-- 积分抵扣暂时注释 -->
        <!-- <div v-if="showIntegral" class="item-lable iscoupon" @click="setIntegral">
          <div class="item-name">
            {{ integralName }}
          </div>
          <div class="item-value">
            <span v-if="!integralInfo.creditUse" class="tips"
              >共{{ integralInfo.creditCount
              }}{{ integralName }},满3000可用</span
            >
            <span v-else class="discount_price_box">{{
              discountPricefroIntegral
                ? `-¥${discountPricefroIntegral}`
                : '去选择'
            }}</span>
          </div>
          <img
            v-if="integralInfo.creditUse"
            src="../../../../images/icon/icon_arrow_left.png"
            class="select_value_icon"
          />
        </div> -->
      </div>
      <!-- 活动立减 -->
      <div v-if="preOrder.activityDiscount">
        <div class="item-lable iscoupon">
          <div class="item-name">限时立减</div>
          <div class="item-value">
            <span class="discount_price_box">-¥{{ preOrder.activityDiscount }}</span>
          </div>
        </div>
      </div>
      <!-- 历史消费金额 -->
      <div v-if="discountList && discountList.length && !fromIntegral" class="card-discount-list">
        <div class="is-discount-list item-lable">
          <div class="item-name">历史消费金额抵扣</div>
          <div class="item-value" v-if="discountList && discountList.length > 1">
            <span class="discount_price_box">-¥{{ discountprice }}</span>
          </div>
        </div>
        <div v-for="(item, index) in discountList" :key="index">
          <transition name="fade" :key="index">
            <div class="discount-item" v-if="index < 0 || unfoldDiscountStatus">
              <div class="item-value_name">{{ item.goodsName }}</div>
              <div class="item-value">-¥{{ item.realPayAmount }}</div>
            </div>
          </transition>
        </div>
        <div v-if="discountList.length > 0" class="unfold-discount" @click="toggelDiscount">
          <span class="unfold-text">
            {{ unfoldDiscountStatus === false ? '展开全部' : '收起' }}
          </span>
          <img
            class="icon-up"
            :class="unfoldDiscountStatus ? 'icon-up' : 'icon-down'"
            src="../../../../images/payment/icon_up.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 折叠 -->

    <!-- 积分抵扣弹窗 -->
    <Popup v-model="integralPop" position="bottom">
      <div class="integral_pop_box">
        <div class="flexbox pop_title">
          {{ integralName }}(剩余{{ integralInfo.creditCount }})
          <img @click="closePop" src="../../../../images/integral/close.png" alt="" />
        </div>
        <ul class="methods_box">
          <li v-for="(item, index) in methodsList" :key="index" @click="chooseItem(index)" class="flexbox">
            <div v-if="item.name">{{ item.name }}</div>
            <div v-else>
              抵扣
              <span class="price_color">¥{{ item.maxPrice }}</span>
              ,使用{{ item.maxIntegral }}{{ integralName }}
            </div>
            <img v-if="mIndex === index" src="../../../../images/integral/select.png" alt="" />
            <img v-else src="../../../../images/integral/select_none.png" alt="" />
          </li>
          <div class="flexbox custom_box" v-if="mIndex === 2">
            使用
            <Field v-model="integralNum" placeholder="点击输入" :disabled="mIndex !== 2" type="digit" />
            <!-- <input
              type="number"
              v-model="integralNum"
              placeholder="点击输入"
              :disabled="mIndex !== 2"
            /> -->
            {{ integralName }},抵
            <span class="price_color">{{ discountIntegral }}</span>
          </div>
          <div class="custom_box_seat" v-else></div>
        </ul>
        <div class="pop_sure_box" @click="popSure">确定</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Popup } from 'mint-ui'
import { Field } from 'vant'
import { mul } from '@/utils/compute-util'
import { orderAmount, orderAmountReal, orderAmountNointegral } from '../options' // 计算订单支付金额
import { formatFloat } from '@/utils'
export default {
  name: 'CardCoupons',
  // props: {
  //   couponList: Array, // 优惠券列表
  //   discountList: Array // 减扣列表
  // },
  components: {
    Popup,
    Field
  },
  data() {
    return {
      unfoldDiscountStatus: true,
      integralPop: false, // 积分抵扣弹窗
      mIndex: null,
      autofocus: true,
      integralNum: null,
      showIntegral: false
    }
  },
  watch: {
    // 输入值超出账户积分数时 赋值最大积分数
    integralNum(data) {
      const { integralInfo } = this
      if (data > integralInfo.maxIntegral) {
        this.integralNum = integralInfo.maxIntegral
      }
    },
    'value.discount': {
      handler(now, old) {
        // console.log('优惠券抵扣now---', now, 'old---', old, 'discountPricefroIntegral', this.discountPricefroIntegral, 'orderAmountNointegral', this.orderAmountNointegral)
        // 选择的抵扣积分 大于 优惠券抵扣后的金额
        if (this.discountPricefroIntegral > this.orderAmountNointegral) {
          this.$store.commit('payment/order/setdiscountIntegralReal', 0)
          this.mIndex = null
          this.integralNum = null
        }
        // 优惠券发生变化时,积分重置
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('args', ['fromIntegral']),
    ...mapGetters('payment/order', [
      'preOrder',
      'paymethod', // 支付方式的选择
      'installment',
      'coupon',
      'openByStages',
      'ratio', // 积分/现金比例
      'discountIntegralReal' // 最后的抵扣积分数量
    ]),
    ...mapGetters('integral/index', ['integralName']),
    orderAmount, // 扣掉优惠券、或者选择分期首付
    orderAmountReal, //
    orderAmountNointegral, // 仅扣掉优惠券等优惠的金额
    goods() {
      return this.preOrder.goodsInfo || {}
    },
    // 已省金额
    reducePrice() {
      let price = this.goods.goodsPrice - parseFloat(this.orderAmountReal)
      price = parseFloat(price).toFixed(2)
      return price > 0 ? price : 0
    },
    // 优惠券的状态显示
    value() {
      const {
        coupon,
        installment
        // paymethod,
        // openByStages
      } = this
      const { couponDiscount: discount, type, content } = coupon
      // 折扣
      const tag = type === 1 ? content + '折' : null

      // 计算优惠券
      const { useCoupon } = installment
      // const isFenqi = paymethod === 2 // 友邻分期不可使用优惠券
      const isFenqi = false // xn：分期商品要打开优惠券
      const disabled = isFenqi ? useCoupon !== 1 : false
      const priceLabel = discount ? '-¥' + discount : ''
      return { tag, disabled, priceLabel, discount }
    },
    couponList() {
      return this.preOrder.couponList || []
    },
    discountList() {
      return this.preOrder.discountList || []
    },
    hasCoupons() {
      return this.couponList.length > 0 // 优惠券列表
    },
    // 积分相关
    integralInfo() {
      const { creditUse, creditCount } = this.preOrder
      let maxIntegral = null
      let maxPrice = null
      const num = mul(this.orderAmountNointegral, this.ratio)
      if (creditCount > num) {
        maxIntegral = num
        maxPrice = this.orderAmountNointegral
      } else {
        maxIntegral = creditCount
        maxPrice = creditCount / this.ratio
      }
      return { creditUse, creditCount, maxIntegral, maxPrice }
    },
    // 自由输入展示的抵扣金额  仅展示
    discountIntegral() {
      return this.discountRate(this.integralNum)
    },
    // 积分最终抵扣金额
    discountPricefroIntegral() {
      return this.discountIntegralReal / this.ratio
    },
    methodsList() {
      return [
        {
          name: `暂不使用${this.integralName}`
        },
        {
          name: '',
          maxPrice: this.integralInfo.maxPrice,
          maxIntegral: this.integralInfo.maxIntegral
        },
        {
          name: '自定义使用数量'
        }
      ]
    },
    // 历史消费总计
    discountprice() {
      return this.discountList.reduce((prev, next) => {
        return formatFloat(prev + next.realPayAmount)
      }, 0)
    }
  },
  created() {
    // this.showIntegral = location.href.indexOf('test') >= 0;
  },
  methods: {
    popSure() {
      switch (this.mIndex) {
        case 0:
          this.$store.commit('payment/order/setdiscountIntegralReal', 0)
          break
        case 1:
          this.$store.commit('payment/order/setdiscountIntegralReal', this.integralInfo.maxIntegral)
          break
        case 2:
          this.$store.commit('payment/order/setdiscountIntegralReal', this.integralNum * 1)
          break
      }
      this.closePop()
    },
    closePop() {
      this.integralPop = false
    },
    discountRate(count) {
      const num = count || 0
      return `¥${(num / this.ratio).toFixed(2)}`
    },
    setCoupon() {
      if (!this.hasCoupons) return
      if (this.value.disabled) return
      // if (this.openByStages) {
      //   console.log('选则')
      // this.$store.commit('payment/order/setbyStages', { openByStages: 0 })
      // }
      const orderId = this.$route.params.id
      this.$router.push({
        name: 'coupons',
        query: { orderId }
      })
    },
    setIntegral() {
      if (!this.integralInfo.creditUse) return
      if (this.openByStages) {
        console.log('选择分期支付时,积分抵扣不可用')
        this.$store.commit('payment/order/setbyStages', { openByStages: 0 })
      }
      this.integralPop = true
    },
    chooseItem(i) {
      this.mIndex = i
    },
    toggelDiscount() {
      this.unfoldDiscountStatus = !this.unfoldDiscountStatus
    }
  }
}
</script>
<style lang="less" scoped>
.custom_box {
  /deep/ .van-cell {
    width: 30%;
    padding: 0;
    margin: 0 5px;
    border-bottom: 1px solid #00b25a;
  }
  /deep/ .van-field__control {
    padding: 3px 0;
    text-align: center;
    -webkit-user-select: auto !important;
  }
}
</style>

<style lang="scss" scoped>
.price_color {
  color: #e65c53;
}
.discount_price_box {
  font-size: 0.3rem;
  font-weight: bold;
  color: #000;
}
.card-coupons {
  text-align: left;
  background-color: #fff;
  .card-coupons_inner {
    padding: 0.48rem 0.48rem 0.24rem;
  }
  .card-order-has_coupons {
    border-bottom: 1px solid #eeeeee;
  }
  // 支付
  .ispay {
    &.item-title {
      font-size: 0.32rem;
      line-height: 0.4rem;
      color: #000;
      // 已省的价格
      .reduce-price {
        margin-left: 0.08rem;
        color: #999;
      }
      // 订单支付的价格
      .order-amount {
        color: #00b25a;
        font-size: 0.28rem;
        font-weight: bold;
        span {
          font-size: 0.4rem;
        }
      }
    }
  }
  // 优惠券
  .iscoupon {
    margin-top: 0.2rem;
  }
  .card-discount-list {
    margin-top: 0.32rem;
  }
  .item-name {
    font-size: 0.28rem;
    color: #000;
    padding: 0.23rem 0;
  }
  .item-lable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.48rem;
    font-size: 14px;
    &.iscoupon {
      margin-bottom: 0;
    }
    .item-lable-tag {
      background: #e65c53;
      color: #fff;
      padding: 0.04rem 0.08rem;
      border-radius: 0.04rem;
      display: inline-block;
      font-size: 0.2rem;
      line-height: 0.26rem;
      margin-left: 0.08rem;
    }
    .item-value_name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .item-value {
      flex: 1 1 140px;
      text-align: right;
      font-size: 0.32rem;
      .tips {
        color: #999999;
        font-size: 0.24rem;
      }
    }
  }
  .discount-item {
    display: flex;
    justify-content: space-between;
    padding: 0.32rem 0 0.23rem 0.16rem;
    color: #999;
    .item-value_name {
      font-size: 0.28rem;
    }
    .item-value {
      font-size: 0.3rem;
      color: #000;
    }
  }
  .is-discount-list {
    padding: 0.32rem 0 0.1rem 0;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #000;
    border-top: 1px solid rgba(235, 235, 235, 1);
    margin-bottom: 0;
  }
  .select_value_icon {
    margin-left: 0.16rem;
    width: 0.1rem;
    height: 0.16rem;
  }
  // 展开减扣
  .unfold-discount {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0.34rem;
    .unfold-text {
      font-size: 0.24rem;
      color: #999;
    }
    .icon-up {
      width: 0.16rem;
      height: 0.16rem;
      margin-left: 0.16rem;
    }
    .icon-down {
      transform: rotate(180deg);
    }
  }
}
.integral_pop_box {
  width: 100vw;
  .pop_title {
    width: 100%;
    height: 0.92rem;
    padding: 0 0.48rem;
    font-size: 0.32rem;
    font-weight: 600;
    justify-content: space-between;
    img {
      display: block;
      width: 18px;
    }
  }
  .methods_box {
    li {
      font-size: 0.28rem;
      border-top: 1px solid #eeeeee;
      width: 100%;
      height: 0.96rem;
      padding: 0 0.48rem;
      justify-content: space-between;
      img {
        display: block;
        width: 15px;
      }
    }
    .custom_box {
      width: 6.54rem;
      height: 0.88rem;
      font-size: 0.28rem;
      background: #f7f9fb;
      border-radius: 0.08rem;
      margin: 0 auto 0;
      justify-content: center;
    }
    .custom_box_seat {
      height: 0.88rem;
    }
    .cover_box {
      opacity: 0.6;
    }
  }
  .pop_sure_box {
    width: 6.54rem;
    height: 0.88rem;
    background: #00b25a;
    border-radius: 0.12rem;
    margin: 0.33rem auto 0.6rem;
    color: #fff;
    font-size: 0.32rem;
    text-align: center;
    line-height: 0.88rem;
  }
}
</style>
